import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative py-24 sm:py-32 min-h-fit" }
const _hoisted_2 = { class: "max-w-3xl mx-auto text-center flex flex-col justify-center items-center" }
const _hoisted_3 = { class: "mt-10 flex items-center gap-x-6" }

import { useI18n } from 'vue-i18n';
import UiContainer from '@/components/ui/UiContainer.vue';
import UiTitle from '@/components/ui/UiTitle.vue';
import UiParagraph from '@/components/ui/UiParagraph.vue';
import UiButton from '@/components/ui/UiButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'WhyUs',
  setup(__props) {

const { t } = useI18n();

// Methods
const openForm = () => {
  window.open(t('pages.home.mainSection.form-url'), '_blank');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UiContainer, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(UiTitle, {
            animation: "fadeIn",
            code: _unref(t)('home.whyUs.tag'),
            size: "5xl"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('home.whyUs.title')), 1)
            ]),
            _: 1
          }, 8, ["code"]),
          _createVNode(UiParagraph, {
            class: "mt-6",
            size: "xl"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('home.whyUs.description')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(UiButton, {
              variant: "primary",
              size: "lg",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (openForm()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('pages.home.mainSection.button')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})